import { render, staticRenderFns } from "./EditDigiBoard.vue?vue&type=template&id=506ae984&scoped=true"
import script from "./EditDigiBoard.vue?vue&type=script&lang=js"
export * from "./EditDigiBoard.vue?vue&type=script&lang=js"
import style0 from "./EditDigiBoard.vue?vue&type=style&index=0&id=506ae984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ae984",
  null
  
)

export default component.exports